// Module
var code = "<react-component name=\"WorkoutsList\"></react-component>\n";
// Exports
module.exports = code;